<template>
  <div class="vc-panel mmp">
    <div class="zxc">
      <div>
        <img class="app-logo" style="width: 100px;" src="@/assets/images/app_logo256.png" alt="应用Logo" />
      </div>
      
      <h1 class="mgt20 color1">ComeKey</h1>
    </div>

  </div>
</template>

<script>
import localUser from '@/commom/local/LocalUser';
import httpClient from '@/commom/http/httpClient';
export default {
  name: 'LoadingPage',
  props: {

  },
  mounted: function () {
    this.loadData()
  },
  methods: {
    ///加载数据
    loadData: function () {
      var user = localUser.getLocalUser()
      var that = this
      if (user == null) {
        setTimeout(() => {
          that.$router.replace("/login-page")
        }, 1000);
        return;
      }

      var req = {
        token: user.token
      }
      httpClient.invoke("UserAPI.TokenLogin", req, function (res) {
        if (res.error) {
          that.$message({ message: res.error })
          that.$router.replace("/login-page")
          return
        }
        localUser.cacheUser(res)
        that.$router.replace("/main-page")
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mmp {
  justify-content: center;
  align-items: center;
}

.zxc {
  width: 500px;
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--ek-mainbody-bgcolor);
  border-radius: 20px;
  flex-direction: column;
}

/* 平板设备适配 */
@media (max-width: 768px) {
  .zxc {
    width: 350px;
    height: 350px;
  }
  
  .app-logo {
    width: 80px !important;
  }
  
  .mgt20 {
    margin-top: 15px;
    font-size: 20px;
  }
}

/* 手机设备适配 */
@media (max-width: 480px) {
  .zxc {
    width: 280px;
    height: 280px;
    border-radius: 15px;
  }
  
  .app-logo {
    width: 60px !important;
  }
  
  .mgt20 {
    margin-top: 10px;
    font-size: 18px;
  }
}

/* 定义渐隐动画 */
@keyframes fadeInOut {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.3;
  }
  100% {
    opacity: 1;
  }
}

/* 应用动画到app-logo */
.app-logo {
  animation: fadeInOut 2s ease-in-out infinite;
}
</style>
